export default __webpack_public_path__ + "static/media/crown.5548768e.svg";